module.exports = __webpack_public_path__ + "static/media/ico_close.f6ff6f0b.svg";